// extracted by mini-css-extract-plugin
export default {"vstack":"kgvWuI_cpjuEuiN1Ke5x"};